export default __webpack_public_path__ + "static/media/baltimoreRavensVideo-2x.7d070dcc.jpg";